import {
  EPreconversationType,
  IPreconversationConfig
} from 'entities/tavus/persona';
import { FormikProps } from 'formik';
import { FC } from 'react';
import FormInput from 'shared/ui/FormInput';

interface IProps {
  formik: FormikProps<any>;
  preconversationConfig?: IPreconversationConfig;
}

export const TavusCallEmbedForm: FC<IProps> = ({
  formik,
  preconversationConfig
}) => {
  return (
    <form
      onSubmit={formik.handleSubmit}
      className="ag-space-y-2 ag-w-full ag-mb-2"
    >
      {preconversationConfig?.fields?.map((field, index: number) => (
        <div key={field.name} className="ag-flex ag-flex-col ag-gap-1.5">
          <FormInput
            formik={formik}
            name={field.name}
            type={field.type === EPreconversationType.TEXT ? 'text' : 'email'}
            className="ag-border !ag-bg-[#ffffff3a] placeholder:ag-text-white ag-w-full ag-border-gray-300 ag-rounded-md ag-px-3 ag-py-2 ag-text-sm"
            placeholder={field.label}
          />
          {formik.touched[field.name] && formik.errors[field.name] && (
            <span className="ag-text-red-500 ag-text-xs">
              {formik.errors[field.name] as unknown as string}
            </span>
          )}
        </div>
      ))}
    </form>
  );
};
